import { CreateInvitationApiResponse } from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { InviteDoctorSubstituteFormValues } from '@/components/forms/invite-doctor-substitute/schema';
import http from '@/utils/http.service';

export type InviteDoctorSubstitutePayload = InviteDoctorSubstituteFormValues & {
  slotId?: string;
};

const inviteDoctorSubstitute = (payload: InviteDoctorSubstitutePayload) => {
  return http.invitations.createInvitation({
    type: 'doctor_substitute_join',
    email: payload.email,
    firstName: payload.firstName,
    lastName: payload.lastName,
    slotId: payload.slotId,
    sites: payload.sitesAccess?.map(({ id, accessType }) => ({
      siteId: id,
      slotType: accessType,
    })),
  });
};

const useInviteDoctorSubstituteMutation = (): UseMutationResult<
  CreateInvitationApiResponse,
  Error,
  InviteDoctorSubstitutePayload
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: inviteDoctorSubstitute,
    onSuccess() {
      toast.success(t('http.invite-doctor-substitute.success'));
    },
  });
};

export default useInviteDoctorSubstituteMutation;
